import type { FunctionComponent } from "react"

import classnames from "classnames"

import { useCareerCenterFetch } from "@/modules/careerCenter/hooks/useCareerCenterFetch"
import { useLocale } from "@/modules/locales/useLocale"
import { Link } from "@/modules/routing/components/Link"
import { getUpdatedHrefWithLocale } from "@/modules/routing/getUpdatedHrefWithLocale"
import { useHref } from "@/modules/routing/hooks/useHref"
import { useCurrentUserFetch } from "@/modules/user/client/hooks/useCurrentUserFetch"

import styles from "./LocaleSelector.module.css"

export const LocaleSelector: FunctionComponent = () => {
  const href = useHref()
  const locale = useLocale()
  const { dataCareerCenter } = useCareerCenterFetch()
  const { dataCurrentUser } = useCurrentUserFetch()
  const locales = dataCareerCenter?.careerCenterConf?.locales || []

  const localesToDisplay =
    !!dataCurrentUser?.isLogged && dataCurrentUser?.attributes.locales ? dataCurrentUser?.attributes.locales : locales

  if (!localesToDisplay.length) return null

  return (
    <div>
      {localesToDisplay.map(localeToDisplay => (
        <Link
          href={getUpdatedHrefWithLocale(href, locale, localeToDisplay)}
          className={classnames(styles.linkLang, {
            [styles.linkLang__active]: locale === localeToDisplay,
          })}
          key={localeToDisplay}
          rel="nofollow"
          prefetch={false}
        >
          {localeToDisplay.toUpperCase()}
        </Link>
      ))}
    </div>
  )
}
